// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3AWTI","content":"styles_content__2aE8x","checkbox":"styles_checkbox__P6ZLg","checkboxLabel":"styles_checkboxLabel__3CFDx"};